import * as React from 'react';

interface InputDesignProps {
  textColor: string;
  textHoverColor: string;
  label: string;
  onClick?: () => void;
}

function TertiaryButton({ onClick, label, textColor, textHoverColor }: InputDesignProps) {
  return (
    <button onClick={onClick} className={`${textColor} px-5 h-[48px] rounded-full transition-colors duration-300 ease-out ${textHoverColor}`} type='button'>
      {label}
    </button>
  );
}

export default TertiaryButton;
